import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsWithholdingsWithholdingProps } from "./types";
import { messages } from "./messages";
import { useFormatter } from "hooks/utils/useFormatter";
import { WITHHOLDINGS_WITHHOLDING_STATUS } from "@letsbit/malcolmlb";
import { HistoryDownloadReceipt } from "../HistoryDownloadReceipt";
import dayjs from "dayjs";
import { RECEIPT_TYPE } from "../HistoryDownloadReceipt/types";

export const HistoryDetailsWithholdingsWithholding: React.FC<
  HistoryDetailsWithholdingsWithholdingProps
> = ({ data: withhold }) => {
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();

  const getStatus = (state?: string) => {
    let stClass = "text-[--color-warning]";
    let st = formatMessage(messages.statusInProgress);

    switch (state) {
      case WITHHOLDINGS_WITHHOLDING_STATUS.PAID:
      case WITHHOLDINGS_WITHHOLDING_STATUS.EXEMPT:
        stClass = "text-[--color-success]";
        st = formatMessage(messages.approved);
        break;
      case WITHHOLDINGS_WITHHOLDING_STATUS.UNPAID:
        stClass = "text-[--color-error]";
        st = formatMessage(messages.rejected);
        break;
    }
    return <span className={stClass}>{st}</span>;
  };

  const cuit = withhold.extra_data.national_id_target;

  return (
    <div className="flex flex-col gap-y-6 pdf:p-10">
      <DetailsField
        label={formatMessage(messages.retainedWithholding)}
        value={`${formatValue(
          withhold.amount,
          withhold.precision,
        )} ${withhold.ticker_id.toUpperCase()}`}
      />
      <DetailsField
        label={formatMessage(messages.baseWithholding)}
        value={`${formatValue(
          withhold.extra_data.base_amount || "",
          withhold.precision,
        )} ${withhold.ticker_id.toUpperCase()}`}
      />
      <DetailsField
        label={formatMessage(messages.aliWithholding)}
        value={`${+(withhold.extra_data.tax?.amount || "0") * 100} %`}
      />
      <DetailsField
        label={formatMessage(messages.sourcePerson)}
        value={
          cuit && cuit?.length >= 11
            ? cuit.slice(0, 2) + "-" + cuit.slice(2, -1) + "-" + cuit.slice(-1)
            : cuit || ""
        }
      />
      <DetailsField
        label={formatMessage(messages.description)}
        value={withhold.extra_data.tax?.description ?? ""}
      />
      <DetailsField
        className="pdf:hidden"
        label={formatMessage(messages.status)}
        value={getStatus(withhold.extra_data.state)}
      />
      <DetailsField
        label={formatMessage(messages.date)}
        value={dayjs(withhold.date).format("HH:mm DD.MM.YYYY")}
      />
      <DetailsField
        label={formatMessage(messages.movementId)}
        value={withhold.tid ?? ""}
        copy
      />
      <DetailsField
        label={formatMessage(messages.linkedId)}
        value={withhold.extra_data.external_id ?? ""}
        copy
      />
      <HistoryDownloadReceipt
        receiptType={RECEIPT_TYPE.WITHHOLDINGS_WITHHOLDING}
        movement={withhold}
      />
    </div>
  );
};
